<template>
  <div class="md:flex md:flex-grow md:overflow-hidden">
    <div class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto" scroll-region>
      <div class="max-w-screen-2xl mx-auto">
        <flash-messages />
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
  },
  props: {
    auth: Object,
  },
}
</script>
